import { Building2, Handshake, MapPin, Target, TrendingUp, Users } from "lucide-react";
import Seo from "@/components/site/Seo";
import EnquiryForm from "@/components/site/EnquiryForm";
import { Notice, PageHero, Reveal, SectionHeading } from "@/components/site/kit";
import { CONSENT, FRANCHISE_FIELDS } from "@/lib/forms";

const BLOCKS = [
  { i: Target, t: "League Concept", d: "A franchise-based T10 tennis-ball cricket competition built for fast, high-energy matches with strong regional identity." },
  { i: Users, t: "12-Franchise Structure", d: "Twelve franchises are planned across Telangana and Andhra Pradesh, each representing a regional identity and fan base." },
  { i: MapPin, t: "Host Cities", d: "Matches are planned at two venues: one in Hyderabad, Telangana and one in Amaravati, Andhra Pradesh." },
  { i: TrendingUp, t: "Commercial Opportunity", d: "Franchises offer a platform for brand building, community engagement, local sponsorship and fan-driven content. Commercial terms are shared only with qualified applicants." },
];

const STEPS = ["Submit an Expression of Interest", "Initial discussion with CGN Sports", "Information pack and evaluation", "Formal application and due diligence", "Franchise allocation and announcement"];

export default function Franchise() {
  return (
    <>
      <Seo title="Franchise Opportunities" description="Own a piece of Telangana–Andhra T10 cricket. Submit an expression of interest for one of 12 planned franchises." />
      <PageHero testid="franchise-hero" eyebrow="Franchise Opportunities" title="Own a Piece of Telangana–Andhra T10 Cricket" image="/images/crowd.jpg">
        Build Your Franchise. Be Part of the League. Express your interest in one of the twelve planned franchises.
      </PageHero>
      <section className="container-x grid gap-4 py-20 sm:grid-cols-2">
        {BLOCKS.map(({ i: I, t, d }, n) => (
          <Reveal key={t} delay={n * 0.06}>
            <div className="card-lift h-full rounded-md border border-white/10 bg-[#112240] p-7">
              <I className="h-7 w-7 text-[#00E5FF]" />
              <h2 className="mt-4 font-display text-3xl uppercase">{t}</h2>
              <p className="mt-3 text-slate-400">{d}</p>
            </div>
          </Reveal>
        ))}
      </section>
      <section className="bg-[#071325] py-20">
        <div className="container-x grid gap-12 lg:grid-cols-[1fr_1.2fr]">
          <div>
            <SectionHeading eyebrow="Participation Process" title="Application Steps" />
            <ol className="mt-8 space-y-3">
              {STEPS.map((s, i) => (
                <li key={s} className="flex items-center gap-4 rounded-md border border-white/10 bg-[#112240] p-4">
                  <span className="font-score text-2xl font-bold text-[#FF5722]">0{i + 1}</span>
                  <span className="font-semibold">{s}</span>
                </li>
              ))}
            </ol>
            <div className="mt-6"><Notice testid="franchise-disclaimer">No franchise fees, investment amounts or financial returns are published or guaranteed. All commercial terms are subject to formal agreement with CGN Sports.</Notice></div>
          </div>
          <div id="eoi" className="scroll-mt-28">
            <div className="mb-6 flex items-center gap-3"><Handshake className="h-7 w-7 text-[#00E5FF]" /><h2 className="font-display text-3xl uppercase">Expression of Interest</h2></div>
            <EnquiryForm testid="franchise-form" fields={FRANCHISE_FIELDS} endpoint="/forms/franchise" submitLabel="Submit Expression of Interest" consentText={CONSENT}
              success="Thank you for your interest in a Telangana–Andhra T10 League franchise. Your expression of interest has been recorded and our team will be in touch." />
          </div>
        </div>
      </section>
      <section className="container-x py-16"><div className="flex items-center gap-3 text-slate-400"><Building2 className="h-5 w-5" />Franchise enquiries are handled confidentially by CGN Sports.</div></section>
    </>
  );
}
